import React from 'react';

interface Props {
  onClose: () => void;
}

const SuccessModal: React.FC<Props> = ({ onClose }) => {
  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50" 
      onClick={handleBackdropClick}
    >
      <div className="bg-white rounded-lg shadow-xl max-w-sm w-full">
        <div className="p-6">
          {/* Success Icon and Title */}
          <div className="flex items-center mb-4">
            <div className="w-8 h-8 bg-green-600 rounded flex items-center justify-center mr-3">
              <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h2 className="text-xl font-bold text-gray-900">CV:n skickade!</h2>
          </div>

          {/* Success Message */}
          <div className="text-gray-700 space-y-2">
            <p>
              Kolla inkorgen om 30s. Är profilerna fel hör av dig, vi har fler.
            </p>
            <p>
              Tipsa gärna andra om denna sida.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;